import { useCallback, useMemo } from 'react';
import {
  useGetFlaggedPostsQuery,
  useHidePostAsAdminMutation,
  useBanUserMutation,
  useUnbanUserMutation,
} from '@/api/client';

const EMPTY_ARRAY: never[] = [];

export function useFlaggedPosts(skip: boolean) {
  const { data, isLoading, refetch } = useGetFlaggedPostsQuery(
    { page: 1, size: 100 },
    { skip }
  );

  const flaggedPosts = useMemo(() => data?.items ?? EMPTY_ARRAY, [data?.items]);
  const [hidePostMutation] = useHidePostAsAdminMutation();
  const [banUserMutation] = useBanUserMutation();
  const [unbanUserMutation] = useUnbanUserMutation();

  const hidePost = useCallback(
    async (postId: number) => {
      try {
        await hidePostMutation(postId).unwrap();
        refetch();
      } catch (error) {
        console.error('Failed to hide post:', error);
      }
    },
    [hidePostMutation, refetch]
  );

  const banUser = useCallback(
    async (userId: number) => {
      try {
        await banUserMutation(userId).unwrap();
        refetch();
      } catch (error) {
        console.error('Failed to ban user:', error);
      }
    },
    [banUserMutation, refetch]
  );

  const unbanUser = useCallback(
    async (userId: number) => {
      try {
        await unbanUserMutation(userId).unwrap();
        refetch();
      } catch (error) {
        console.error('Failed to unban user:', error);
      }
    },
    [unbanUserMutation, refetch]
  );

  return {
    flaggedPosts,
    isLoading,
    hidePost,
    banUser,
    unbanUser,
  };
}
